<script lang="ts" setup>
import type { BreadcrumbSeparatorProps } from '.';

import { cn } from '@/utils';
import { ChevronRightIcon } from '@radix-icons/vue';

const props = defineProps<BreadcrumbSeparatorProps>();
</script>

<template>
	<li
		role="presentation"
		aria-hidden="true"
		:class="
			cn(
				'flex items-center font-matter-sq text-xl leading-normal tracking-[-0.4px] text-primary-light-1 [&>svg]:size-3.5',
				props.class
			)
		"
	>
		<slot> / </slot>
	</li>
</template>
